export const getOverallStatus = (order) => {
  const hasArt = order.artUploaded === true;
  const admin = order.adminApproval;
  const client = order.clientApproval;
  const hasInsurance = !!order.insuranceFile;
  const sentToTravis = order.sentToTravis === true;
  const hasPrizeboard = !!order.prizeboardFile;

  // 🚧 Incomplete
  if (!hasArt) return "Incomplete - Need Art";

  // 🟡 Approvals
  if (admin !== "Approved") return "Pending Admin Approval";
  if (client !== "Approved") return "Pending Client Approval";

  // 📄 Art is done, but missing Insurance
  if (!hasInsurance) return "Art Complete - No Insurance";

  // ✅ Sent to Travis but no prizeboard yet
  if (sentToTravis && !hasPrizeboard) return "Pending Prizeboard Approval";

  // 📦 Missing prizeboard in general
  if (!hasPrizeboard) return "Art Complete - No Prizeboard";

  // 🎉 All done!
  return "Order Complete";
};
